import { Link } from "react-router-dom";

export default function Privacy() {
  const pageStyle = {
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f4f6f8",
    padding: "20px",
  };

  const cardStyle = {
    maxWidth: "800px",
    width: "100%",
    backgroundColor: "#ffffff",
    padding: "40px",
    borderRadius: "12px",
    boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
  };

  const headingStyle = {
    fontSize: "28px",
    marginBottom: "24px",
    color: "#222",
  };

  const paragraphStyle = {
    marginBottom: "16px",
    color: "#444",
    fontSize: "16px",
  };

  const backStyle = {
    display: "inline-block",
    marginBottom: "20px",
    color: "#2563eb",
    textDecoration: "none",
    fontSize: "14px",
    cursor: "pointer",
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <Link to="/" style={backStyle}>
          ← Back
        </Link>

        <h1 style={headingStyle}>Privacy Policy</h1>

        <p style={paragraphStyle}>
          JobSniper collects and processes user data such as resumes, job
          descriptions, and email addresses for the purpose of providing
          skill-gap analysis and generating personalized learning flows.
        </p>

        <p style={paragraphStyle}>
          We do not sell or share your data with third parties except trusted
          service providers required to run the platform (analytics, hosting,
          payment).
        </p>

        <p style={paragraphStyle}>
          Users can request data deletion anytime by contacting
          jobsniperteam@gmail.com.
        </p>

        <p style={paragraphStyle}>
          By using JobSniper, you consent to this Privacy Policy.
        </p>
      </div>
    </div>
  );
}